












import { defineComponent } from '@nuxtjs/composition-api';

import PageHeroDescription from '../PageHeroDescription/PageHeroDescription.vue';
import YoutubeVideoTile from '../YoutubeVideoTile/YoutubeVideoTile.vue';

export default defineComponent({
  name: 'BrandHero',
  components: {
    PageHeroDescription,
    YoutubeVideoTile,
  },
  props: {
    brand: {
      type: Object,
      required: true,
    },
    brand_video: {
      type: [Object, String],
      required: true,
    },
    expert_link: {
      type: Object,
      required: true,
    },
  },
});
